import { memo } from 'react'
import { UserCircleIcon, CheckCircleIcon, XCircleIcon, ShieldCheckIcon } from '@heroicons/react/24/outline'

/**
 * UserInfoDisplay - Shows user information in view mode
 * Displays avatar, name, status badges, and metadata
 */
const UserInfoDisplay = memo(function UserInfoDisplay({
  user
}) {
  return (
    <div className="flex items-center mb-6">
      <div className="h-20 w-20 bg-gray-200 rounded-full flex items-center justify-center">
        {user.avatar ? (
          <img src={user.avatar} alt={user.firstName} className="h-20 w-20 rounded-full object-cover" loading="lazy" />
        ) : (
          <UserCircleIcon className="h-12 w-12 text-gray-400" />
        )}
      </div>
      <div className="ml-6">
        <h2 className="text-2xl font-bold text-gray-900">
          {user.firstName} {user.lastName}
        </h2>
        <div className="flex items-center gap-2 mt-2">
          {user.isActive ? (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
              <CheckCircleIcon className="h-4 w-4 mr-1" />
              Active
            </span>
          ) : (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
              <XCircleIcon className="h-4 w-4 mr-1" />
              Inactive
            </span>
          )}
          {user.isAdmin && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
              <ShieldCheckIcon className="h-4 w-4 mr-1" />
              Administrator
            </span>
          )}
          {user.isVerified && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              <CheckCircleIcon className="h-4 w-4 mr-1" />
              Verified
            </span>
          )}
        </div>
      </div>
    </div>
  )
})

export default UserInfoDisplay
